module.exports = __webpack_public_path__ + "static/media/covid19.6ce9074d.png";